import { useCallback } from 'react';

import { hasHeroMatch } from '../../../telemetry/hero';
import { ReportHeroComponentRendered } from '../context';

import { UsePageLoadTelemetryCallbackOptions, usePageLoadTelemetryCallback } from './usePageLoadTelemetryCallback';

type UseReportHeroComponentRenderedCallbackOptions = UsePageLoadTelemetryCallbackOptions & {
  readonly onHeroComponentRendered: () => void;
};

export type UseReportHeroComponentRenderedCallback = (
  options: UseReportHeroComponentRenderedCallbackOptions
) => ReportHeroComponentRendered;

export const useReportHeroComponentRenderedCallback: UseReportHeroComponentRenderedCallback = ({
  onHeroComponentRendered,
  ...options
}) => {
  const pageLoadTelemetryCallback = usePageLoadTelemetryCallback(options);

  const { hero } = options;

  return useCallback(
    (component, heroOptions) => {
      if (hasHeroMatch(component, hero)) {
        onHeroComponentRendered();
      }
      pageLoadTelemetryCallback(component, heroOptions);
    },
    [hero, pageLoadTelemetryCallback, onHeroComponentRendered]
  );
};
